<template>
  <h1 class="page-headline__title">
    {{ title }}
  </h1>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline__title {
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 1.6;
}
</style>
